export enum IvaTypeEnums{
    pleno = 1,
    sobreUtilidad = 2
  }